export default __webpack_public_path__ + "static/media/ford-music-logo.f84a62b7.png";